
import { definedDicts } from '@hll/full';

export const equityTextMap = definedDicts([
  {
    key: '1001', // 权益code
    value: 1,
    text: '月结账户', // 权益名称
    featureDesc: '月结账户', // 开通功能
  },
  
  {
    key: '2001', 
    value: 2,
    text: '组织管理', 
    featureDesc: '员工或部门管理', 
  },
  {
    key: '3001', 
    value: 3,
    text: '用车保障', 
    featureDesc: '收藏司机',
  },
  {
    key: '4002', 
    value: 4,
    text: '专享保障', 
    featureDesc: '货损无忧险',
  },
  {
    key: '3002', 
    value: 5,
    text: '财务费控', 
    featureDesc: '员工或部门限额',
  },
  {
    key: '3002', 
    value: 6,
    text: '财务费控', 
    featureDesc: '下单审批',
  },
  {
    key: '2001', 
    value: 7,
    text: '组织管理', 
    featureDesc: '企业关联',
  },
] as const);

export const EquityTextKV = equityTextMap.kv;
export const EquityTextVK = equityTextMap.vk;
export const EquityTextVMap = equityTextMap.vMap;